<lcs-loading-overlay [show]="callState | lcsCallState : 'loading'"
   ><div mat-dialog-title class="dialog-header"
      >@if (!promptIdIfUpdatingExistingPromptFile) {
      <h3 class="dialog-title">Add Prompt</h3>
      }@if (promptIdIfUpdatingExistingPromptFile) {
      <h3 class="dialog-title">Update Prompt File</h3>
      }<button type="button" mat-icon-button tabindex="-1" (click)="onCloseClick()"
         ><mat-icon>close</mat-icon></button
      ></div
   ><form [formGroup]="form" (ngSubmit)="onCreate(createPromptOptionValue)"
      ><mat-dialog-content
         >@if (!promptIdIfUpdatingExistingPromptFile) {
         <mat-form-field class="flex-full no-padding"
            ><mat-label>Name</mat-label
            ><input matInput autocomplete="off" type="text" formControlName="name" id="name" required #name />@if
            (form.get('name')?.hasError('required')) {
            <mat-error>Name is required. </mat-error>
            } @if (form.get('name')?.hasError('pattern')) {
            <mat-error> Name has incorrect pattern. Must contain characters </mat-error>
            }</mat-form-field
         >
         }@if (!promptIdIfUpdatingExistingPromptFile) {
         <div
            >@if (onlyPromptTypeOption) {
            <div class="add-prompt-static-type"
               ><span class="add-prompt-static-type-label">Type</span
               ><span class="add-prompt-static-type-value">{{ onlyPromptTypeOption | addSpaces }}</span></div
            >
            } @else { @if (!creatingNewFromExtension) {
            <mat-form-field class="flex-full no-padding"
               ><mat-label>Type</mat-label
               ><input
                  ndtPromptTypeSelect
                  autocomplete="off"
                  type="text"
                  [lcsSingleSelect]="promptTypeSelect"
                  ndtPromptTypeSelect
                  formControlName="typeId"
                  id="typeId"
                  required
               /><ndt-prompt-type-select
                  #promptTypeSelect
                  [excludedPromptTypes]="excludedPromptTypes"
                  [includedPromptTypes]="includedPromptTypes"
                  [includeEmptyOption]="includeEmptyOption"
               ></ndt-prompt-type-select
               >@if (form.get('typeId')?.hasError('required')) {
               <mat-error>Prompt Type is required.</mat-error>
               }</mat-form-field
            >
            } }</div
         >
         }@if ((creatingNewFromExtension || includeReusableOption) && promptIdIfUpdatingExistingPromptFile === null) {
         <mat-checkbox class="reusable-checkbox" formControlName="isReusable">Reusable</mat-checkbox>
         }@if (!dontIncludeRecordingOption) {
         <mat-button-toggle-group
            class="add-prompt-source-toggle-group"
            name="createPromptOption"
            [value]="createPromptOptionValue"
            [hideSingleSelectionIndicator]="true"
            (change)="onCreateOptionChange($event)"
            ><mat-button-toggle value="file"
               ><mat-icon>upload_file</mat-icon><span>Upload a File</span></mat-button-toggle
            ><mat-button-toggle value="microphone"
               ><mat-icon>mic</mat-icon><span>Use My Microphone</span></mat-button-toggle
            ><mat-button-toggle value="recording-extension"
               ><mat-icon>dialpad</mat-icon><span>Call an Extension</span></mat-button-toggle
            ><mat-button-toggle value="recording-external"
               ><mat-icon>call</mat-icon><span>Call an External Number</span></mat-button-toggle
            ></mat-button-toggle-group
         >
         }@if (!dontIncludeRecordingOption && createPromptOptionValue === 'microphone') {
         <div class="recording-option-container"
            ><div class="recording-container"
               >@if (!isRecording && !audioSrc) {
               <button class="start-button" mat-raised-button (click)="startRecording()">Start Recording</button>
               }@if (isRecording && !audioSrc) {
               <button class="stop-button" mat-raised-button (click)="stopRecording()">Stop Recording</button>
               }@if (!isRecording && audioSrc) {
               <button class="clear-button" mat-raised-button (click)="abortRecording()">Clear Recording</button>
               }<audio class="recording-audio-player" controls [src]="audioSrc"></audio></div
            >@if (isRecording && !audioSrc) {
            <div class="recording-message"
               ><mat-icon class="recording-icon">fiber_manual_record</mat-icon> {{ recording }}
            </div>
            }@if (validateRecording() && !isRecording) {
            <mat-error class="recording-error">Please record a prompt. </mat-error>
            }</div
         >
         }@if (createPromptOptionValue === 'recording-extension' && !dontIncludeRecordingOption) {
         <div class="recording-option-container"
            ><mat-form-field class="flex-full"
               ><mat-label>Extension to Call</mat-label
               ><input
                  [lcsSingleSelect]="routeToExtensionSelect"
                  [accountId]="this.accountId"
                  [extensionType]="1"
                  ndtExtensionSelect
                  type="text"
                  formControlName="destinationExtension"
                  [name]="'routeToExtension' + index"
               /><ndt-extension-select
                  #routeToExtensionSelect
                  [disabled]="!canEdit"
                  [isIncludeEmptyOption]="canEdit"
               ></ndt-extension-select
               >@if (!form.controls.destinationExtension.valid) {
               <mat-error matError>Please select a valid destination extension.</mat-error>
               }</mat-form-field
            ></div
         >
         }@if (createPromptOptionValue === 'recording-external' && !dontIncludeRecordingOption) {
         <div class="recording-option-container"
            ><mat-form-field class="flex-full"
               ><mat-label>External Phone Number to Call</mat-label
               ><input matInput type="text" formControlName="destinationNumber" [name]="'destinationNumber'" />@if
               (form.get('destinationNumber')?.hasError('pattern')) {
               <mat-error matError>Please enter a valid destination phone number</mat-error>
               }@if (form.get('destinationNumber')?.hasError('required')) {
               <mat-error>Destination Number is required.</mat-error>
               }</mat-form-field
            ></div
         >
         }@if (createPromptOptionValue === 'file') {
         <div class="recording-option-container"
            ><ndt-file-upload
               class="prompt-file-upload"
               label="Upload a new prompt"
               acceptedFileTypes=".wav, .mp3"
               formControlName="fileAttachment"
               required
            ></ndt-file-upload
            >@if (form.get('fileAttachment')?.value === null) {
            <mat-error>Please upload a .wav or .mp3 file. </mat-error>
            }</div
         >
         }</mat-dialog-content
      ><mat-dialog-actions>
         @if (includeAddAnother) {
         <button
            title="Create and Add Another"
            type="button"
            mat-stroked-button
            (click)="onCreateAndAddAnother(createPromptOptionValue)"
            >{{
               createPromptOptionValue === 'file' || createPromptOptionValue === 'microphone'
                  ? 'Save and Add Another'
                  : 'Call and Add Another'
            }}</button
         >
         } @if (createPromptOptionValue === 'file' || createPromptOptionValue === 'microphone') {
         <button type="submit" title="Create" mat-raised-button color="primary">Save</button>
         }@if ( (createPromptOptionValue === 'recording-extension' || createPromptOptionValue === 'recording-external')
         && !dontIncludeRecordingOption ) {
         <button type="submit" title="Create" mat-raised-button color="primary">Call </button>
         }</mat-dialog-actions
      ></form
   ></lcs-loading-overlay
><div class="recording-status-container"
   >@if (this.recordingPromptCallStatus && callState | lcsCallState : 'loading') {
   <h3 class="recording-prompt-call-status-label">
      {{ this.recordingPromptCallStatus }}
      <span class="dots"></span
   ></h3>
   }@if (this.recordingPromptCallStatus && callState | lcsCallState : 'loading') {
   <span class="phone-icon material-icons">call</span>
   }@if (this.recordingPromptCallStatus && callState | lcsCallState : 'loading') {
   <button class="cancel-button" type="cancel" title="Cancel" mat-raised-button (click)="onCancelPromptRecordingCall()"
      >Cancel</button
   >
   }
</div>
